module.exports = __webpack_public_path__ + "static/img/w.e879aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp/w.jpg
// module id = Un9u
// module chunks = 0